module.exports = __webpack_public_path__ + "fonts/TiemposHeadline-BoldItalic.9e01513e.woff2";